import { useNavigate } from '@tanstack/react-router'
import { ROUTES } from '@/shared/constants/routes'

export function useUnderConstruction() {
  const navigate = useNavigate()

  function goHome() {
    navigate({ to: ROUTES.HOME })
  }

  return { goHome }
}
